import React from 'react';
import Box from '../Box/Box';

type TPills = {
  children: React.ReactNode;
  className?: string;
};

const Pills = ({ children, ...rest }: TPills) => (
  <Box {...rest} as="section" name="Pills">
    {children}
  </Box>
);

export default Pills;
